export const audioPreviousIcon = `
<svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
  <path d="M0 12V0H2V12H0ZM13 12L4 6L13 0V12Z" fill="var(--zbp-svg-primary-color, black)"/>
</svg>
`;
